import { render, staticRenderFns } from "./showMsg.vue?vue&type=template&id=5292980a&scoped=true&"
import script from "./showMsg.vue?vue&type=script&lang=js&"
export * from "./showMsg.vue?vue&type=script&lang=js&"
import style0 from "./showMsg.vue?vue&type=style&index=0&id=5292980a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5292980a",
  null
  
)

export default component.exports